import React, { useState, useEffect, useCallback } from 'react';
import { connect } from "react-redux";
import { Button } from "antd";
import { setStateSelStationInfo } from '@store/actions/common'
import { stationgisApi } from '@api/newApi';

const Pages = ({ userInfo, nextStep, dispatch }) => {
  // 厂站列表
  const [stationsList, setStationsList] = useState([]);

  useEffect(() => {
    getStationsList();
    return () => {
    }
  }, []);

  // 获取厂站列表
  const getStationsList = () => {
    stationgisApi.selectGisStationList(userInfo.stationIds ? userInfo.stationIds.split(',') : []).then(
      (res) => {
        if (res.status * 1 === 0) {
          setStationsList(res.data);
        }
      })
  }

  // 点击选择厂站
  const selStationFn = (item) => {
    sessionStorage.setItem('selStationInfo', JSON.stringify(item))
    dispatch(setStateSelStationInfo(item))
    nextStep(1)
  }

  return (
    <div className="step1-box step-box">
      <h4>
        <span>请选择厂站进行工艺单元配置</span>
      </h4>
      <div className="station-list-box">
        {
          stationsList.map((item, index) =>
            <Button key={index}
              type="primary"
              onClick={() => selStationFn(item)}
              size="large">{item.name}</Button>
          )
        }
      </div>
    </div>
  )
}
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
